import {
  BankClosureTool,
  CarModelReliabilityTool,
  ChildBenefitCalculator,
  IncomeTaxCalculator,
  MarriageAllowanceTool,
  NationalInsuranceCalculator,
  PensionCalculator,
  PensionWithdrawalCalculator,
} from './importers'

export const toolComponentMap = {
  bankClosure: {
    component: BankClosureTool,
    dataValidation: ['bank', 'branch', 'localAuthority', 'closingDate', 'postcode'],
  },
  councilTax: {
    component: BankClosureTool,
    dataValidation: ['country', 'area', 'A', 'B', 'C', 'D', 'E', 'F', 'G', 'H', 'I'],
  },
  nationalInsuranceCalculator: {
    component: NationalInsuranceCalculator,
    dataValidation: [
      'employedAdditional',
      'employedRate',
      'financialYear',
      'highRate',
      'lowRate',
      'lowThreshold',
      'mediumThreshold',
      'minLowThreshold',
      'selfAdditional',
      'selfRate',
    ],
  },
  marriageAllowance: {
    component: MarriageAllowanceTool,
    isRecordValid: (recordKeys) =>
      ['id', 'question', 'answer', 'text', 'conclusion'].some((key) => recordKeys.includes(key)),
  },
  incomeTaxCalculator: {
    component: IncomeTaxCalculator,
    dataValidation: [
      'taxYear',
      'personalAllowanceLimit',
      'lowRate',
      'midRate',
      'highRate',
      'lowThreshold',
      'midThreshold',
      'highThreshold',
      'startRateScot',
      'basicRateScot',
      'intermediateRateScot',
      'higherRateScot',
      'topRateScot',
      'lowThresholdScot',
      'startThresholdScot',
      'basicThresholdScot',
      'intermediateThresholdScot',
      'advancedThresholdScot',
      'highThresholdScot',
      'lowRateNi',
      'mediumRateNi',
      'highRateNi',
      'lowThresholdNi',
      'mediumThresholdNi',
    ],
  },
  pensionCalculator: {
    component: PensionCalculator,
    dataValidation: [
      'womenDob',
      'womenYears',
      'womenMonths',
      'womenPensionDate',
      'menDob',
      'menYears',
      'menMonths',
      'menPensionDate',
    ],
  },
  childBenefitCalculator: {
    component: ChildBenefitCalculator,
    dataValidation: ['taxYear', 'earningLimit', 'initialRate', 'additionalRate', 'amountOverLimit'],
  },
  pensionWithdrawalCalculator: {
    component: PensionWithdrawalCalculator,
    dataValidation: [
      'taxYear',
      'personalAllowanceLimit',
      'taxFreePercentage',
      'lowRate',
      'midRate',
      'highRate',
      'lowThreshold',
      'midThreshold',
      'highThreshold',
      'lowThresholdScot',
      'startThresholdScot',
      'basicThresholdScot',
      'midThresholdScot',
      'highThresholdScot',
      'startRateScot',
      'basicRateScot',
      'midRateScot',
      'higherRateScot',
      'topRateScot',
    ],
  },
  carModelReliability: {
    component: CarModelReliabilityTool,
    dataValidation: [
      'brand',
      'modelAndYear',
      'description',
      'zero',
      'five',
      'ten',
      'link',
      'image',
    ],
  },
}

export type ComponentType = keyof typeof toolComponentMap
